'use client';
import styled from 'styled-components';
import {
  LeftAligned,
  OllieLogo,
  RightAligned,
  CenterAligned,
} from '@web/molecules/Header/NavigationBar/styles';

export const MarketingHeaderWrapper = styled.div`
  @media (max-width: 1199px) {
    ${OllieLogo} {
      order: 1 !important;
      margin-left: ${props => props.theme.spacing(6)};
    }
    ${CenterAligned} {
      order: 2;
    }
    ${RightAligned} {
      order: 3;
    }
    ${LeftAligned} {
      order: 4 !important;
      margin: ${props => props.theme.spacing(0, 4)};
    }
  }
`;
